import React, { useEffect } from 'react'
import { RadioGroup, Radio } from 'react-radio-group'
import { connect } from 'react-redux'

import { setAnswer } from '../actions/answers'
import { setLatestQuestion, setCompleted } from '../actions/tracker'
import { setSectionScore, setSubSectionScore } from '../actions/score'

import calculateSubSectionScore from '../selectors/subSectionScore'
import calculateSectionScore from '../selectors/sectionScore'

const Question = ({ 
    answers,
    existingAnswer, 
    qId, 
    question, 
    scores,
    secId, 
    setAnswer,
    setCompleted,
    setLatestQuestion, 
    setSectionScore,
    setSubSectionScore,
    subSecId,
    tracker,
}) => {
    const handleChange = (value) => {
        const newAnswer = parseInt(value);
        setAnswer({ [qId]: newAnswer }, secId, subSecId);
        setLatestQuestion(secId, subSecId, qId);
    }

    useEffect(() => {
        const subSectionAnswers = Object.values(answers[secId][subSecId]).filter((answer) => answer !== "");
        const numAnswered = subSectionAnswers.length;
        ((numAnswered === tracker[secId][subSecId].totalQuestions) && setCompleted(secId, subSecId));
        setSubSectionScore(subSecId, Math.round(calculateSubSectionScore(subSectionAnswers)));
    }, [answers])

    useEffect(() => {
        const subSectionData = Object.values(scores.subSections).filter((subSection) => (subSection.section === secId) && !!subSection.score);
        const subSectionScores = (subSectionData.length === 0) ? undefined : subSectionData.map((subSection) => [subSection.score, subSection.weight]);
        !!subSectionScores && setSectionScore(secId, calculateSectionScore(subSectionScores));
    }, [scores.subSections])

    return (
        <RadioGroup 
            className="cell small-12 large-8 large-offset-2 question-box" 
            Component="fieldset" 
            name={ question.id } 
            selectedValue={ existingAnswer } 
            onChange={ handleChange }
        >
            <legend>{ question.text }</legend>
            <div className="input--radio"><Radio id="no" className="input" value="1"/><label className="bold" htmlFor="no">No</label></div>
            <div className="input--radio"><Radio id="somewhat" className="input" value="2"/><label className="bold" htmlFor="somewhat">Somewhat</label></div>
            <div className="input--radio"><Radio id="definitely" className="input" value="3"/><label className="bold" htmlFor="definitely">Definitely</label></div>
            <hr className="divider"></hr>
            <div className="input--radio"><Radio id="na" className="input" value="0"/><label className="bold" htmlFor="na">Not Applicable</label></div>
        </RadioGroup>
    )
}

const mapStateToProps = (state, props) => {
    const secId = props.question.secId
    const subSecId = props.question.subSecId
    const qId = props.question.qId

    return {
        answers: state.answers,
        existingAnswer: `${state.answers[secId][subSecId][qId]}`,
        qId,
        scores: state.scores,
        secId,
        subSecId,
        tracker: state.tracker
    }
}

const mapDispatchToProps = (dispatch) => ({
    setAnswer: (answer, secId, subSecId) => dispatch(setAnswer(answer, secId, subSecId)),
    setCompleted: (secId, subSecId) => dispatch(setCompleted(secId, subSecId)),
    setLatestQuestion: (secId, subSecId, qId) => dispatch(setLatestQuestion(secId, subSecId, qId)),
    setSectionScore: (secId, score) => dispatch(setSectionScore(secId, score)),
    setSubSectionScore: (subSecId, score) => dispatch(setSubSectionScore(subSecId, score))
})

export default connect(mapStateToProps, mapDispatchToProps)(Question)


// WEBPACK FOOTER //
// ./src/components/Question.js